import type { FC} from 'react';
import { memo } from 'react';
import { NavLink } from 'react-router-dom';

import { isEqual } from 'lodash';

import { Badge } from '@mui/material';

import { Notifications } from '@shared/assets/icons';

import { useAppSelector } from 'library/hooks/common';
import { selectSortNotifications } from 'library/redux/notifications';

import * as st from './styles.module.scss';

export const ButtonNotifications: FC = memo(() => {
	const newNotifications = useAppSelector(selectSortNotifications, isEqual);
	return (
		<NavLink to="/notifications" className={st.btn}>
			<Badge
				color="secondary"
				variant="dot"
				invisible={!newNotifications.unread.length}
				classes={{ dot: st.dot }}
			>
				<Notifications />
			</Badge>
		</NavLink>
	);
});
